import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { useDataIntegrations } from './DataIntegrationsProvider'
import { MinusCircleIcon } from 'images'

export function Integration({ integration }) {
  const { deleteIntegration, loading, error } = useDataIntegrations()

  return (
    <div
      className={cn('integrations_integration', {
        'integrations_integration--loading': loading[`delete.${integration.id}`],
      })}
    >
      <div className="integrations_integration__service-name">{integration.service_name}</div>
      <div className="integrations_integration__label_and_key">
        <div className="integrations_integration__label">{integration.name}</div>
        <div className="integrations_integration__api-key">{integration.secret_preview}</div>
      </div>
      {error[`delete.${integration.id}`] && (
        <div className="integrations_integration__error">{error[`delete.${integration.id}`]}</div>
      )}
      <i
        title="remove"
        className="integrations_integration__remove"
        onClick={() => deleteIntegration(integration.id)}
      >
        <MinusCircleIcon />
      </i>
    </div>
  )
}

Integration.propTypes = {
  integration: PropTypes.shape({
    id: PropTypes.string.isRequired,
    service_name: PropTypes.string.isRequired,
    secret_preview: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

export default function Integrations() {
  const { integrations } = useDataIntegrations()

  return (
    <div className="integrations_list">
      {integrations.map((integration) => (
        <Integration key={integration.id} integration={integration} />
      ))}
    </div>
  )
}
